import React, { useContext } from 'react'
import * as NavigationMenuPrimitive from '@radix-ui/react-navigation-menu'
import { cn } from '@/lib/utils'
import { NavigationMenuContext } from '@/components/_headers/_shared/navigationMenuContext'
import useGlobalStore from '@/store/useGlobalStore'

const NavigationMenuViewport = React.forwardRef<
  React.ElementRef<typeof NavigationMenuPrimitive.Viewport>,
  React.ComponentPropsWithoutRef<typeof NavigationMenuPrimitive.Viewport>
>(({ className, ...props }, ref) => {
  const { isNavigationMenuOpen, navigationHeight, offsetHeight } = useContext(
    NavigationMenuContext,
  )
  const {
    app: { isSearchBarActive },
  } = useGlobalStore()

  return (
    <div
      className={cn('absolute bottom-0')}
      style={{ top: isSearchBarActive ? offsetHeight + 100 : offsetHeight }}
    >
      <NavigationMenuPrimitive.Viewport
        style={isNavigationMenuOpen ? { height: navigationHeight } : {}}
        className={cn(
          'origin-top-center left-0  w-[var(--radix-navigation-menu-viewport-width)]',
          'overflow-hidden border bg-popover text-popover-foreground shadow-lg',
          'transition-height h-0 duration-300 ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out',
          className,
        )}
        ref={ref}
        {...props}
      />
    </div>
  )
})

NavigationMenuViewport.displayName =
  NavigationMenuPrimitive.Viewport.displayName

export default NavigationMenuViewport
